import React from 'react';
import { Route } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import ConfigComponents from './ConfigComponents'
import ConfigAssetClass from './ConfigAssetClass'


export default function Config({ match }) {
    return (
        <div className="content">
            <div className="container-fluid">
                <Route path={`${match.url}/components`} component={ConfigComponents} />
                <Route path={`${match.url}/asset-class`} component={ConfigAssetClass} />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Config/index.js